import { applicationAiTestControllerCreate } from './applicationAiTestControllerCreate'
import { applicationAiTestControllerGetSchoolsAiTestByIin } from './applicationAiTestControllerGetSchoolsAiTestByIin'

export const applicationAITestService = { applicationAiTestControllerCreate, applicationAiTestControllerGetSchoolsAiTestByIin }